import { BaseAction } from "../../../core/actions/BaseAction";
import { getAllOfferWithoutExchange } from "../../../Lib/Utils/booking";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookedOffer } from "../../../Orchestrator/Types/Index";
import { IGetBookingDetailStatusActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";
import dayjs from "dayjs";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { AdmissionStatusEnum, BookingStatusEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";

export class GetBookingDetailStatusAction extends BaseAction<IDefaultActionResult, IGetBookingDetailStatusActionParams> {

    override async run(): Promise<IDefaultActionResult> {
        const result: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const { booking } = this.params!;
            let bookingStatus: BookingStatusEnum | "" = ""
            if (booking) {
                const allBookedOfferWithoutExchange: IBookedOffer[] = getAllOfferWithoutExchange(booking?.booking?.bookedOffers)

                //Check booking is past booking
                if (booking?.booking?.trips.length > 0) {
                    const tripStartDateTime = booking?.booking?.trips[0].startTime
                    // const givenDate = dayjs(tripStartDateTime).startOf('day');
                    // const currentDate = dayjs().startOf('day')          

                    //Convert tripStartDateTime Date to the Dubai time zone
                    const givenDate = dayjs(tripStartDateTime).tz("Asia/Dubai");
                    //Get current dubai time
                    const currentDate = dayjs().tz("Asia/Dubai")

                    //Check tripStartDateTime dat and current date as per dubai                                        
                    if (givenDate.isBefore(currentDate)) {
                        bookingStatus = BookingStatusEnum.PAST
                    }
                }
                //Check at least any one fulfilled
                if (bookingStatus === "") {
                    for (let i = 0; i < allBookedOfferWithoutExchange.length; i++) {
                        const bookSummaries = allBookedOfferWithoutExchange[i].admissions;
                        const isAnyFulfilled = bookSummaries.find(d => d.status === AdmissionStatusEnum.FULFILLED)
                        if (isAnyFulfilled) {
                            bookingStatus = BookingStatusEnum.FULFILLED
                            break;
                        }
                    }
                }

                //Check all are refunded.
                // if (bookingStatus === "") {
                //     for (let i = 0; i < allBookedOfferWithoutExchange.length; i++) {
                //         const bookSummaries = allBookedOfferWithoutExchange[i].admissions;
                //         const isAnyFulfilled = bookSummaries.find(d => d.status === "REFUNDED")
                //         if (isAnyFulfilled) {
                //             bookingStatus = "REFUNDED"
                //             break;
                //         }
                //     }
                // }
                const allRefunded = allBookedOfferWithoutExchange.length > 0 &&
                    allBookedOfferWithoutExchange.every(offer =>
                        offer.admissions.length > 0 &&
                        offer.admissions.every(admission => admission.status === AdmissionStatusEnum.REFUNDED || admission.status === AdmissionStatusEnum.RELEASED)
                    );
                if (allRefunded) {
                    bookingStatus = BookingStatusEnum.REFUNDED;
                }
            }
            updateRecoilState("bookingConfirmStatusAtom", bookingStatus)
            result.status = "success"
            result.data = bookingStatus
        } catch (error) {
            console.error("Error in GetBookingDetailStatusAction:", error);
        } finally {
            return result
        }
    }
}

// Create a singleton instance
export const getBookingDetailStatusAction = new GetBookingDetailStatusAction(); 